import type { Theme } from '@mui/material';
import { badgeClasses } from '@mui/material';

// import type { Components } from '@mui/material/styles';
import { SHAPE_CIRCULAR, SHAPE_SQUARE } from '@/mui/constants';

export const CUSTOM_ATTRIBUTE_SHAPE = 'data-0';

export default function MUIBadge(theme: Theme) /* : Components['MuiBadge'] */ {
  return {
    defaultProps: {
      color: 'primary',
    },
    variants: [
      {
        props: { [CUSTOM_ATTRIBUTE_SHAPE]: SHAPE_SQUARE },
        style: {
          [`.${badgeClasses.badge}`]: {
            borderRadius: 0,
          },
        },
      },
      {
        props: { [CUSTOM_ATTRIBUTE_SHAPE]: SHAPE_CIRCULAR },
        style: {
          [`.${badgeClasses.badge}`]: {
            borderRadius: theme.shape.borderRadiusCircular,
          },
        },
      },
    ],
    styleOverrides: {
      badge: {
        fontWeight: 400,
        fontSize: theme.typography.body2.fontSize,
      },
      standard: {
        minWidth: 18,
        height: 18,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
      dot: {
        width: 10,
        height: 10,
        borderRadius: '50%',
      },
      colorNeutral: {
        color: theme.palette.shades[900],
        backgroundColor: theme.palette.shades[300],
      },
    },
    // variants: [],
  };
}
